export default __webpack_public_path__ + "static/media/value2.4b2ec4fd.png";